import { SimulationParameterType, type SimulationParameterView } from '@nexelem/graphne-api';
import { isValid } from 'date-fns';

export const isCheckedParameterValue = (value: unknown) => value === 'true' || value === 't';

export const toBooleanParameterValue = (checked: boolean) => (checked ? 'true' : 'false');

export const parseParameterDefaultValue = (param: SimulationParameterView) => {
  const raw = param.defaultValue;

  if (param.parameterType === SimulationParameterType.Boolean) {
    return toBooleanParameterValue(isCheckedParameterValue(raw));
  }

  if (param.parameterType === SimulationParameterType.Int) {
    return raw != null ? Number(raw) : undefined;
  }

  if (param.parameterType === SimulationParameterType.Date) {
    return raw != null && isValid(new Date(raw)) ? new Date(raw) : undefined;
  }

  return raw || undefined;
};

export type ParameterGroupData = {
  name: string;
  parameters: SimulationParameterView[];
};

export const groupParameters = (parameters: SimulationParameterView[]): ParameterGroupData[] => {
  const groups: ParameterGroupData[] = [];

  parameters.forEach((param) => {
    const name = param.groupName ?? '';
    const group = groups.find((group) => group.name === name);

    if (group) {
      group.parameters.push(param);
    } else {
      groups.push({ name, parameters: [param] });
    }
  });

  groups.forEach((group) => {
    group.parameters.sort((a, b) => (a.ordinal ?? a.id) - (b.ordinal ?? b.id));
  });

  return groups;
};
